import { render, staticRenderFns } from "./FacetNav.vue?vue&type=template&id=3914787f&"
import script from "./FacetNav.vue?vue&type=script&lang=js&"
export * from "./FacetNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports